import axios from "axios";

export default {
  getFactoryCategoryByStateId(selectedStateId) {
    return axios.get(`/state/factory-category/${selectedStateId}`);
  },

  getFactoryCategoryByDistrictName(selectedDistrictName) {
    return axios.get(`/district/factory-category/${selectedDistrictName}`);
  }
};
